import { useState } from 'react';

import { Flex } from '@chakra-ui/react';
import { useReviewCreationData } from 'reducers/reviewCreationSlice';

import { REVIEW_PROVIDER_TYPES } from 'constants/ProjectConstants';

import { Accordion } from 'uiToolkitV1/Accordion';
import { AccordionButton, AccordionItem2, AccordionPanel2 } from 'uiToolkitV1/Accordion/Accordion';
import { SelectionGridTable } from 'uiToolkitV1/SelectionGridTable';
import { TooltipInfoV1 } from 'uiToolkitV1/TooltipInfoV1';
import { TextBodyMedium, TextHeader4 } from 'uiToolkitV1/Typography';

import { useTemplateMetadata } from '../../../Hooks/dataHooks/shareResultsDataHooks';
import { PreviewFormButton } from '../../FormFillingExperience/PreviewFormButton';
import { ReviewerTypeVisibilitySettingsManagerDemo } from './ReviewerTypeVisibilitySettingsManagerDemo';

export const ManagerReviewerSettingsDemo = ({ feedbackFormId }: { feedbackFormId: number }) => {
  const { reviewCycleId } = useReviewCreationData();
  const managerTemplateMetadata = useTemplateMetadata({
    reviewCycleId,
    feedbackFormId,
    providerType: REVIEW_PROVIDER_TYPES.MANAGER,
  });

  const [scoreSettings, setScoreSettings] = useState({
    isShowGoalRating: true,
    isShowQNARating: true,
    isShowCompetencyRating: true,
    outcome: true,
    finalScore: true,
  });

  const managerTemplateHasQuestions = managerTemplateMetadata?.template?.questionCount > 0;

  const hasGoalQuestions =
    managerTemplateMetadata?.template?.templateSetting?.overallRatingDistribution?.PERFORMANCE > 0;
  const hasCompetencyQuestions =
    managerTemplateMetadata?.template?.templateSetting?.overallRatingDistribution?.POTENTIAL > 0;
  const hasQNAQuestions = managerTemplateMetadata?.template?.templateSetting?.overallRatingDistribution?.QNA > 0;

  const tableHeaders = [];
  if (hasGoalQuestions) tableHeaders.push('Goal section score');
  if (hasCompetencyQuestions) tableHeaders.push('Competency section score');
  if (hasQNAQuestions) tableHeaders.push('Q&A section score');
  tableHeaders.push('Final Score');
  tableHeaders.push('Outcomes');

  const tableOptions = [];
  if (hasGoalQuestions) {
    tableOptions.push({
      label: 'Show',
      checked: scoreSettings.isShowGoalRating,
    });
  }
  if (hasCompetencyQuestions) {
    tableOptions.push({
      label: 'Show',
      checked: scoreSettings.isShowCompetencyRating,
    });
  }
  if (hasQNAQuestions) {
    tableOptions.push({
      label: 'Show',
      checked: scoreSettings.isShowQNARating,
    });
  }
  tableOptions.push({
    label: 'Show',
    checked: scoreSettings.finalScore,
  });
  tableOptions.push({
    label: 'Show',
    checked: scoreSettings.outcome,
  });
  const onChangeHandlers = [];
  if (hasGoalQuestions) {
    onChangeHandlers.push((checked: boolean) => setScoreSettings((prev) => ({ ...prev, isShowGoalRating: checked })));
  }
  if (hasCompetencyQuestions) {
    onChangeHandlers.push((checked: boolean) =>
      setScoreSettings((prev) => ({ ...prev, isShowCompetencyRating: checked }))
    );
  }
  if (hasQNAQuestions) {
    onChangeHandlers.push((checked: boolean) => setScoreSettings((prev) => ({ ...prev, isShowQNARating: checked })));
  }
  onChangeHandlers.push((checked: boolean) => setScoreSettings((prev) => ({ ...prev, finalScore: checked })));
  onChangeHandlers.push((checked: boolean) => setScoreSettings((prev) => ({ ...prev, outcome: checked })));

  const handleChange = (checked: boolean, i: number, j: number) => {
    onChangeHandlers[j]?.(checked);
  };

  return (
    <Accordion defaultIndex={0} allowMultiple allowToggle boxShadow="none !important">
      <AccordionItem2 sxProps={{ borderBottom: 'none !important' }}>
        <AccordionButton>
          <Flex justifyContent="space-between" alignItems="center" flexGrow={1}>
            <TextHeader4 bold>Manager visibilty</TextHeader4>
            <PreviewFormButton
              feedbackFormId={feedbackFormId}
              providerType={REVIEW_PROVIDER_TYPES.MANAGER}
              isDisabled={!managerTemplateHasQuestions}
              label="Preview report card for Manager"
              isShareResultPage
            />
          </Flex>
        </AccordionButton>
        <AccordionPanel2 pl="32px !important" mb="10px">
          <Flex flexDir="column" gap={3}>
            <Flex alignItems="center" gap={2}>
              <TextBodyMedium>What scores will be seen by the manager in the final score summary</TextBodyMedium>
              <TooltipInfoV1 title="Post the review publish visibility of Self and Manager score to the Manager" />
            </Flex>
            <SelectionGridTable headers={tableHeaders} rows={[tableOptions]} onChange={handleChange} />
          </Flex>
        </AccordionPanel2>
        <ReviewerTypeVisibilitySettingsManagerDemo feedbackFormId={feedbackFormId} />
      </AccordionItem2>
    </Accordion>
  );
};
